import { useState, useEffect } from 'react';

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-[100]">
      <button
        type="button"
        onClick={scrollToTop}
        className={`
          flex items-center justify-center
          w-10 h-10 rounded-full
          bg-gradient-to-b from-brand-electric-blue to-brand-neon-green
          text-white shadow-lg shadow-brand-neon-green/20
          transition-all duration-300 transform
          hover:-translate-y-1 hover:scale-110
          ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}
        `}
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up text-base"></i>
      </button>
    </div>
  );
};
